var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowError)?_c('div',{staticClass:"sam-branding-input-error"},[_vm._v(" Branding is required. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }